import { render, staticRenderFns } from "./MessageReactions.vue?vue&type=template&id=9beb1dbe&"
import script from "./MessageReactions.vue?vue&type=script&lang=js&"
export * from "./MessageReactions.vue?vue&type=script&lang=js&"
import style0 from "./MessageReactions.vue?vue&type=style&index=0&id=9beb1dbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports